import {makeStyles} from "@material-ui/core";
import AppColors from './../colors/AppColors';
import {blueGrey, grey, purple, indigo, deepOrange} from '@material-ui/core/colors';

export const useOnBoarderStyle = makeStyles((theme) => ({
    firstIntro: {
        background: `linear-gradient(-45deg, ${AppColors.PRIMARY_COLOR_WITH_ALPHA} 75%, ${AppColors.ACCENT_COLOR_ALPHA} 120%)`,
        backgroundColor: '#004d40e1',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    secondIntro: {
        background: `url(${require('./../images/wallet_background.png')})`,
        backgroundColor: '#004d40e1',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    thirdIntro: {
        background: `url(${require('./../images/wallet_background.png')})`,
        backgroundColor: '#9C760CFA',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    },
    onboarderMsg1: {
        color: AppColors.WHITE,
        fontSize: 45,
        fontWeight: 600,
        lineHeight: 1.2,
        paddingLeft: 30,
        paddingRight: 30,
        paddingTop: 65,
        textAlign: 'center'
    },
    onboaderMsg2: {
        textAlign: 'center',
        fontSize: 23,
        paddingLeft: 30,
        paddingRight: 30,
        lineHeight: 1.4,
        color: AppColors.lightenOrDarken(blueGrey[200], 20),
        marginTop: 30,
        marginBottom: 30,
    },
    onboaderMsg3: {
        textAlign: 'center',
        fontSize: 23,
        paddingLeft: 30,
        paddingRight: 30,
        lineHeight: 1.4,
        color: AppColors.lightenOrDarken(blueGrey[100], 30),
        marginTop: 30,
        marginBottom: 30,
    },
    getStartedButton: {
        color: AppColors.WHITE,
        paddingLeft: 60,
        paddingRight: 60,
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 23,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: AppColors.BLUE,
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(AppColors.BLUE, 30),
        },
        '&:disabled': {
            backgroundColor: AppColors.lightenOrDarken(AppColors.GREY_TEXT, 60),
        }
    },
    getStartedButtonSmall: {
        color: AppColors.WHITE,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 20,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: AppColors.BLUE,
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(AppColors.BLUE, 30),
        },
        '&:disabled': {
            backgroundColor: AppColors.lightenOrDarken(AppColors.GREY_TEXT, 60),
        }
    },
    winFreeBTCBtn: {
        color: AppColors.WHITE,
        paddingLeft: 60,
        paddingRight: 60,
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 23,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: purple[900],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(purple[900], 30),
        }
    },
    winFreeBTCBtnSmall: {
        color: AppColors.WHITE,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 20,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: purple[900],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: AppColors.lightenOrDarken(purple[900], 30),
        }
    },
    multiplyBTCBtn: {
        color: AppColors.WHITE,
        paddingLeft: 60,
        paddingRight: 60,
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 23,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: indigo[900],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: indigo[900],
        }
    },
    multiplyBTCBtnSmall: {
        color: AppColors.WHITE,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 20,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: indigo[900],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: indigo[900],
        }
    },
    investmentButton: {
        color: AppColors.WHITE,
        paddingLeft: 60,
        paddingRight: 60,
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 23,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: deepOrange[700],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: deepOrange[700],
        }
    },
    investmentButtonSmall: {
        color: AppColors.WHITE,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 20,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: deepOrange[700],
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: deepOrange[700],
        }
    },
    lotteryButton: {
        color: AppColors.WHITE,
        paddingLeft: 60,
        paddingRight: 60,
        paddingBottom: 10,
        paddingTop: 10,
        fontSize: 23,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: '#ec760c',
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: '#ec760c',
        }
    },
    lotteryButtonSmall: {
        color: AppColors.WHITE,
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 5,
        paddingTop: 5,
        fontSize: 20,
        borderRadius: 5,
        fontWeight: 600,
        textTransform: 'none',
        transition: 'all .2s ease-in-out',
        backgroundColor: '#ec760c',
        '&:hover': {
            transform: 'scale(0.9)',
            backgroundColor: '#ec760c',
        }
    },
    dot: {
        width: 13,
        height: 13,
        margin: 5,
        backgroundColor: `${grey}`
    },
    dotActive: {
        width: 13,
        height: 13,
        margin: 5,
        backgroundColor: 'white'
    },
    speechBubble: {
        position: 'relative',
        background: '#00aabb',
        borderRadius: '.4em',
        '&:after': {
            content: '',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            width: '0',
            height: '0',
            border: '20px solid transparent',
            borderTopColor: '#00aabb',
            borderBottom: 0,
            borderLeft: 0,
            marginLeft: '-10px',
            marginBottom: '-20px'
        }
    },
    rememberMeLabelStyle: {
        fontSize: 14
    },
    rememberMeCheckStyle: {
        color: `${AppColors.lightenOrDarken(AppColors.GREY_TEXT, 10)}`,
        '&:checked': {
            color: AppColors.ACCENT_COLOR,
        }
    },
    orangeChecked: {
        backgroundColor: '#F1952D',
        width: 20,
        borderRadius: 2,
        height: 20,
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 20,
            height: 20,
            backgroundImage:
                "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
                " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
                "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#F1952D',
        },
    },
}));
